/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type developmentVerificationStep_root$ref: FragmentReference;
declare export opaque type developmentVerificationStep_root$fragmentType: developmentVerificationStep_root$ref;
export type developmentVerificationStep_root = {|
  +me: ?{|
    +id: string
  |},
  +$refType: developmentVerificationStep_root$ref,
|};
export type developmentVerificationStep_root$data = developmentVerificationStep_root;
export type developmentVerificationStep_root$key = {
  +$data?: developmentVerificationStep_root$data,
  +$fragmentRefs: developmentVerificationStep_root$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "developmentVerificationStep_root",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "me",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = 'ca064c6a11ef03922befd2adeecb5134';

export default node;
